import { Component } from '@angular/core';

@Component({
    selector: 'app-new-extra-product',
    templateUrl: './new-extra-product.component.html',
    styleUrls: ['./new-extra-product.component.scss'],
    standalone: true
})
export class NewExtraProductComponent {


  //  id="id_{{ priceTables.priceTypeId }}{{ slotDetail.resourceId }}"


   decreaseValue(priceTypeId,resourceId){
    if(resourceId){
      let quantityElement = <HTMLInputElement>document.querySelector('#id_' + priceTypeId + resourceId);
      if(+quantityElement.value === 1)return
      quantityElement.value = (parseInt(quantityElement.value, 10) - 1).toString();
    } 
  }

  increaseValue(priceTypeId,resourceId){
    if(resourceId){
      let quantityElement = <HTMLInputElement>document.querySelector('#id_' + priceTypeId + resourceId);
      quantityElement.value = (parseInt(quantityElement.value, 10) + 1).toString();
    }
  }

}
